/* import __COLOCATED_TEMPLATE__ from './step.hbs'; */
/**

## Step

The Step component is a singular component to be used within the [navigation](../../navigation.html)
of a [Selector Control component](../../../selector-control.html)

```example
@title Inactive

@hbs
{{selector-control/navigation/item/ste


p label="Inactive Step"}}
```

```example
@title Active

@hbs
{{selector-control/navigation/item/step label="Active Step" isActive=true}}
```

```example
@title Passing a block
@description You can pass a block to use as the text of the step instead of passing a string through the label param

@hbs
{{#selector-control/navigation/item/step isActive=true}}
  Step with <em>Emphasis</em>
{{/selector-control/navigation/item/step}}
```

@param {String} label - Text for the step. Can also pass a block instead
@param {Boolean} isActive=false - Determines whether or not the step is in an active state
@param {Number} StepIndex - 0-based index for the step. This is set automatically if you are using it within a Selector Navigation([selector-control](https://fuse-docs.sqprod.co/components/glass/selector-control.html) component.
*/

import Component from '@ember/component';
import { computed } from '@ember/object';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'span',
  classNames: ['breadcrumbs__crumb'],
  attributeBindings: ['data-test-selector-control-step'],
  'data-test-selector-control-step': computed('isActive', function () {
    if (this.get('isActive')) {
      return 'active';
    } else {
      return 'inactive';
    }
  }),
  isActive: false,
  actions: {
    select() {
      if (this.onSelect) {
        this.onSelect(this.get('stepIndex'));
      }
    }
  }
});